<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div v-if="formActive">
            <div class="text-center p-2" style="margin-bottom: 30px">
                <h3>{{ $t('account.changeMail.title') }}</h3>
            </div>

            <form @submit.prevent="handleOnSubmit">
                <div class="row">
                    <label for="new_mail" class="col-sm-4 col-form-label">{{ $t('account.changeMail.newMail') }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.new_mail" type="mail" id="new_mail" name="new_mail"
                            class="form-control"
                            v-bind:class="{ 'is-invalid': errors.new_mail}"/>
                        <div v-if="errors.new_mail" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.new_mail) }}</div>
                    </div>
                    <div v-if="(!errors.new_mail)" class="invalid-errors-hiddens"></div>
                </div>

                <div class="row">
                    <label for="new_mail_confirmation" class="col-sm-4 col-form-label">{{ $t('account.changeMail.newMailConfirm')
                        }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.new_mail_confirmation" type="mail" id="new_mail_confirmation"
                            name="new_mail_confirmation"
                            class="form-control"
                            v-bind:class="{ 'is-invalid': errors.new_mail_confirmation}"/>
                        <div v-if="errors.new_mail_confirmation" class="invalid-feedback invalid-errors">{{ $t('errors.' +errors.new_mail_confirmation) }}</div>
                    </div>
                    <div v-if="(!errors.new_mail_confirmation)" class="invalid-errors-hiddens"></div>
                </div>

                <div class="text-center">
                    <div class="pb-4 ">
                        <button type="submit" :disabled="submitBtnDisabled()" class="btn btn-primary">{{ $t('account.edit.submit') }}</button>
                    </div>
                </div>

                <div>

                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import userService from '../../services/UserService';

    export default {
        name: 'change-mail',

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                submitted: false,
                formActive:false,
            }
        },

        mounted() {
        },

        created() {
            var params = [];
            this.token = this.$route.query.t;
            params['token'] = this.token;
            this.fetchUserData(params);
        },

        methods: {
            getDefaultFields() {
                return {
                    new_mail: '',
                    new_mail_confirmation: '',
                    token: this.$route.query.t,
                };
            },

            submitBtnDisabled() {
                return this.submitted;
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    await userService.resetMail({
                        ...this.formData,
                    });
                    this.$router.push('/change-mail-confirm');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                                if (errItem.message[0] === 'USER_TOKEN_DATA_WITHIN_24H') {
                                    this.$router.push('/change-mail-error');
                                }
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                }
            },

            async fetchUserData(params) {
                this.errors = this.getDefaultFields();

                try {
                    await userService.confirmChangeEmailRequest({
                        ...params
                    });
                    this.formActive = true;

                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                                this.$router.push('/change-mail-error');
                            }
                        })
                    }
                }
            },

        }
    }
</script>

<style scoped>
    .password-requirement {
        margin: 40px 0px 40px 0px; 
    }
    .password-requirement p {
        margin-bottom: 1em;
    }
    .password-requirement ul {
        list-style: disc;
    }
    .password-requirement ul li {
        margin-left: 3.5em;
    }

    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 479px) { /*ウィンドウ幅が479px以上の場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 67px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:30px;
            height:auto !important;
            height:30px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { /*ウィンドウ幅が最大479pxまでの場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 51px;
            margin-top: 3px;
            margin-bottom: 5px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 4px;
        }
        .col-form-label{
            padding-top: 0px;
        }
        .btn-position{
            padding-top: 10px;
        }
    }
</style>
